import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomerProjectType } from '../../customer-project-type.enum';
import { Status } from '../../status.interface';
import { Utils } from '../../utils.class';
import { Workarea } from '../../workarea.class';

@Component({
    selector: 'app-workarea-drill',
    templateUrl: './workarea-drill.component.html',
    standalone: false,
})
export class WorkareaDrillComponent implements OnInit {
    @ViewChild('workareaForm', { static: true }) workareaForm: FormGroup;
    @Output()
    public formValid = new EventEmitter<FormGroup>();
    @Input()
    public workarea: Workarea;
    @Input()
    statuses: Status[];
    @Input()
    fieldOptions: object;
    public Utils = Utils;

    @HostListener('change', ['$event'])
    inputChanged(event) {
        this.formValid.emit(this.workareaForm);
    }

    ngOnInit(): void {
        this.formValid.emit(this.workareaForm);
        this.workarea.type = CustomerProjectType.drillings;
    }
}
